import React, { Fragment } from 'react'
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import EntryFormView from './widgets/EntryFormView';
import EntryListView from './widgets/EntryListView';

const MahasulEntryMasterFormView = () => {
    return (
        <Fragment>
            <Fragment>
                <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <EntryFormView />
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <EntryListView />
                    </Grid>
                </Grid>
            </Fragment>
        </Fragment>
    )
}

export default MahasulEntryMasterFormView